// Небольшой кэш GET-запросов публичного сайта (новости). При возврате на
// страницу данные показываются сразу, без загрузки, и тихо обновляются.

const cache = new Map<string, unknown>();
const inflight = new Map<string, Promise<unknown>>();

export class HttpError extends Error {
  constructor(public status: number) {
    super(`Ошибка ${status}`);
  }
}

/** Данные из кэша, если уже загружались. */
export function peekJson<T>(url: string): T | undefined {
  return cache.get(url) as T | undefined;
}

/** Загрузить JSON (повторный параллельный запрос не создаётся). */
export function fetchJsonCached<T>(url: string): Promise<T> {
  const running = inflight.get(url);
  if (running) return running as Promise<T>;
  const p = fetch(url)
    .then((res) => {
      if (!res.ok) throw new HttpError(res.status);
      return res.json() as Promise<T>;
    })
    .then((data) => {
      cache.set(url, data);
      return data;
    })
    .finally(() => inflight.delete(url));
  inflight.set(url, p);
  return p;
}

/** Загрузить заранее (наведение на карточку) — ошибки не важны. */
export function prefetchJson(url: string): void {
  if (cache.has(url) || inflight.has(url)) return;
  fetchJsonCached(url).catch(() => undefined);
}
